import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import "./product.css";
import { Toast, ProductCard } from "components/ui";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import useProductInCatalogCheck from "hooks/useStockInCatalog";
import useStockInCatalog from "hooks/useStockInCatalog";
// import { useCart } from "context/CartContext";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, initCart, initEditCategory, removeEditCategory, removeFromCart } from "store/cartSlice";

const Product = React.memo(({ product, allData }) => {
  // console.log("Child=======",product)
  const location = useLocation();
  const innerChnages = location?.state?.innerChnages;
  const isEdit = location?.state?.edit || innerChnages;
  const isEditCatagory = location?.state?.isEditCatagory;
  const updateCatagoryData = location?.state?.updateCatagory;

  // console.log("isEdit===>>>.",isEdit)
  // console.log("isEditCatagory===>>>.",isEditCatagory)

  const dispatch = useDispatch();

  const isInCart = useSelector((state) => state.cart.cartData.some((item) => item?.styleNumber === product?.styleNumber));

  const isSelectedForEdit = useSelector((state) => state.editCategory.data.some((item) => item?.styleNumber === product?.styleNumber));

  // console.log("location====>>>",location)

  const isPlacingOrder = location?.state?.newName === "Create Order";

  const { setBtnTitle, btnTitle, presentInCatalog } = useStockInCatalog(product, isEditCatagory, updateCatagoryData);

  const [open, setOpen] = useState(false);
  // const [selectedCartProducts, setSelectedCartProducts] = useState({});
  const { setCountCart, countCart, isEditCatagoryData, setIsEditCatagoryData } = useGlobalContext();
  // const { addToCart, removeFromCart } = useCart();

  // const addtoCart = React.useCallback(() => {
  //   setBtnTitle("Added");
  //   setOpen(true);
  // }, [setBtnTitle]);

  // const removeCart = React.useCallback(
  //   (productToRemove) => {
  //     setBtnTitle("Add");
  //     let getCartData = JSON.parse(sessionStorage.getItem("CartData")) || [];
  //     // getCartData = getCartData.filter((item) => (item.id || item._id) !== productToRemove.id);
  //     getCartData = getCartData.filter((item) => item.styleNumber !== productToRemove.styleNumber);
  //     // getCartData.pop(productToRemove);
  //     sessionStorage.setItem("CartData", JSON.stringify(getCartData));
  //     // setCountCart((prevCount) => prevCount - 1);
  //     window.dispatchEvent(new Event("cartUpdated"));
  //   },
  //   [setBtnTitle, setCountCart]
  // );

  // const handleAddToCartBtn = () => {
  //   setBtnTitle("Added");
  //   addToCart(selectedCartProducts, isPlacingOrder);
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  // const handleRemoveCart = () => {
  //   setBtnTitle("Add");
  //   removeFromCart(selectedCartProducts);
  //   sessionStorage.setItem("RecentlyRemoved", JSON.stringify(selectedCartProducts));
  //   window.dispatchEvent(new Event("cartUpdated"));
  // };

  const selectedCartProducts = React.useMemo(
    () => ({
      ...product,
      isAddedInCart: true,
    }),
    [product]
  );

  const handleAddToCartBtn = React.useCallback(() => {
    dispatch(
      addToCart({
        product: selectedCartProducts,
        location: location,
      })
    );
  }, [dispatch, selectedCartProducts]);

  const handleRemoveCart = React.useCallback(() => {
    dispatch(removeFromCart(selectedCartProducts));
  }, [dispatch, selectedCartProducts]);

  useEffect(() => {
    dispatch(initCart());
  }, [dispatch]);

  // useEffect(() => {
  //   setBtnTitle(isInCart ? "Added" : "Add");
  // }, [isInCart, setBtnTitle]);

  useEffect(() => {
    if (isEditCatagory === true) {
      if (isSelectedForEdit) {
        setBtnTitle("Selected");
      } else {
        setBtnTitle("Select");
      }
      return;
    }
    // NORMAL MODE
    if (isInCart) {
      setBtnTitle("Added");
    } else {
      setBtnTitle("Add");
    }
  }, [isEditCatagory, isSelectedForEdit, isInCart, setBtnTitle]);

  useEffect(() => {
    dispatch(initEditCategory(updateCatagoryData));
  }, [dispatch]);

  const addCatagoryForEdit = React.useCallback(() => {
    setBtnTitle("Selected");
    setOpen(true);
  }, [setBtnTitle]);

  // const removeCatagoryForEdit = React.useCallback(
  //   (productToRemove) => {
  //     setBtnTitle("Select");
  //     let getUpdateCatagoryData = JSON.parse(sessionStorage.getItem(updateCatagoryData)) || [];
  //     getUpdateCatagoryData = getUpdateCatagoryData.filter((item) => (item.id || item._id) !== productToRemove.id);
  //     sessionStorage.setItem(updateCatagoryData, JSON.stringify(getUpdateCatagoryData));
  //     setIsEditCatagoryData(getUpdateCatagoryData || []);
  //     window.dispatchEvent(new Event("UpdateSubCategory"));
  //   },
  //   [setBtnTitle, updateCatagoryData]
  // );

  const removeCatagoryForEdit = React.useCallback(
    (productToRemove) => {
      setBtnTitle("Select");

      dispatch(
        removeEditCategory({
          storageKey: updateCatagoryData,
          id: productToRemove.id || productToRemove._id,
        })
      );
    },
    [dispatch, setBtnTitle, updateCatagoryData]
  );

  // useEffect(() => {
  //   setSelectedCartProducts(() => ({
  //     ...product,
  //     isAddedInCart: true,
  //   }));
  // }, []);

  // const handleClose = (reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }
  //   setOpen(false);
  // };

  const handleClose = React.useCallback((reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  }, []);

  return (
    <>
      <Grid
        item
        // xs={12}
        // sm={6}
        // md={4}
        // lg={4}
        // xl={4}
        className="product"
      >
        <ProductCard
          data={product}
          selectedCartProducts={selectedCartProducts}
          style={{ width: isEdit ? "474px" : "474px", minWidth: isEdit ? "474px" : "474px" }}
          {...(innerChnages && {
            isBtn: true,
            addtoCart: !isEditCatagory ? handleAddToCartBtn : addCatagoryForEdit,
            removeCart: !isEditCatagory ? handleRemoveCart : removeCatagoryForEdit,
            btnTilte: btnTitle,
            presentInCatalog: presentInCatalog,
            updateCatagoryData: updateCatagoryData,
          })}
          allData={allData}
        />
        {!isEditCatagory && (
          <Toast
            open={open}
            msg={`Design Has Been Added To Cart ${countCart} `}
            autoHideDuration={2000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            ContentProps={{
              sx: { backgroundColor: "#50C878" },
            }}
          />
        )}
      </Grid>
    </>
  );
});

export default React.memo(Product);
